import { Link } from 'react-router-dom'
import { Nav, Col } from 'react-bootstrap'
import { BoxArrowRight } from 'react-bootstrap-icons'
import { NavigationContainerItem } from 'types/types'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectUserIsAuthenticated } from 'store/authslice'

export interface NavSectionProps {
  navItem: NavigationContainerItem
  callback: () => void
}

const NavSection = (props: NavSectionProps) => {
  const isAuthenticated = useSelector(selectUserIsAuthenticated)

  return (
    <Col lg={4}>
      <span className="h5 d-block mb-4">{props.navItem.title}</span>
      <ul className="list-unstyled d-flex flex-column gap-3">
        {props.navItem.children &&
          props.navItem.children.map((navItem, index) => (
            <React.Fragment key={`navitem-${index}`}>
              {(!isAuthenticated && navItem.pageTypeName === 'Inloggningssida') ||
              navItem.pageTypeName !== 'Inloggningssida' ? (
                <Nav.Item as="li">
                  <Nav.Link
                    as={Link}
                    className="text-white d-flex align-items-center gap-2"
                    to={navItem.permaLink}
                    onClick={() => props.callback()}
                  >
                    {navItem.pageTypeName === 'Inloggningssida' && <BoxArrowRight />} {navItem.title}
                  </Nav.Link>
                </Nav.Item>
              ) : null}
            </React.Fragment>
          ))}
        <li></li>
      </ul>
    </Col>
  )
}

export default NavSection
